import React from 'react';
import styled from '@emotion/styled';

import { fluidRange, calcEm } from '~/styles';

const StyledHeader = styled.h2`
  ${fluidRange('fontSize', '28px', '56px')};
  line-height: 1.08;
  text-transform: uppercase;
  padding-bottom: ${calcEm(38, 56)};
  border-bottom: black solid thin;
  margin-bottom: ${calcEm(38, 56)};
  width: 100%;
  text-align: center;
`;

const StyledContent = styled.div`
  ${fluidRange('fontSize', '16px', '29.5px')};
`;

function ImportantSafetyInformationModal() {
  return (
    <>
      <StyledHeader>IMPORTANT SAFETY INFORMATION</StyledHeader>

      <StyledContent>
        <p>PLEASE SEE FULL DIRECTIONS FOR USE</p>
        <p>
          <strong>
            RHA<sup>&reg;</sup> Collection of Fillers
          </strong>
        </p>
        <p>
          <u>
            <strong>Indications</strong>
          </u>
        </p>
        <p>
          The RHA<sup>&reg;</sup> collection of resilient hyaluronic acid (HA) fillers includes
          RHA<sup>&reg;</sup>&nbsp;2, RHA<sup>&reg;</sup>&nbsp;3 and RHA<sup>&reg;</sup>&nbsp;4.
        </p>
        <p>
          RHA<sup>&reg;</sup>&nbsp;2 and RHA<sup>&reg;</sup>&nbsp;3 are indicated for injection into the mid-to-deep
          dermis for the correction of moderate to severe dynamic facial
          wrinkles and folds, such as nasolabial folds; and RHA<sup>&reg;</sup>&nbsp;4 is indicated
          for injection in the deep dermis to superficial subcutaneous tissue
          for the correction of moderate to severe dynamic facial wrinkles and
          folds, such as nasolabial folds; in adults 22 or older.
        </p>
        <p>
          <strong>IMPORTANT SAFETY INFORMATION</strong>
        </p>
        <p>
          <u>
            <strong>Contraindications</strong>
          </u>
        </p>
        <p>
          Do not use in patients who have severe allergies, marked by a history
          of anaphylaxis or multiple severe allergies, or in patients with a
          history of allergies to gram-positive bacterial proteins or local
          anesthetics of the amide type, such as lidocaine.
        </p>
        <p>Do not use in patients with bleeding disorders. </p>
        <p>
          <u>
            <strong>Warnings</strong>
          </u>
        </p>
        <p>
          Do not inject into blood vessels. Introduction of these products into
          the vasculature may lead to embolization, occlusion of the vessels,
          ischemia, or infarction. Take extra care when injecting soft-tissue
          fillers; for example, inject the product slowly and apply the least
          amount of pressure necessary. Rare, but serious, adverse events
          associated with the intravascular injection of soft-tissue fillers in
          the face have been reported and include temporary or permanent vision
          impairment, blindness, cerebral ischemia or cerebral hemorrhage
          leading to stroke, skin necrosis, and damage to underlying facial
          structures. Immediately stop the injection if a patient exhibits any
          of the following symptoms: changes in vision, signs of a stroke,
          blanching of the skin, or unusual pain during or shortly after the
          procedure. Patients should receive prompt medical attention and,
          possibly, evaluation by an appropriate healthcare professional
          specialist should an intravascular injection occur.
        </p>
        <p>
          Product use at specific sites in which an active inflammatory process
          or infection is present should be deferred until the underlying
          process has been controlled.
        </p>
        <p>
          <u>
            <strong>Precautions</strong>
          </u>
        </p>
        <p>
          These products should only be used by healthcare professionals who
          have appropriate training, experience, and knowledge of facial
          anatomy.
        </p>
        <p>
          Discuss the potential risks of soft-tissue injections with your
          patients prior to treatment and ensure that patients are aware of
          signs and symptoms of potential complications.
        </p>
        <p>
          The safety and effectiveness for the treatment of anatomic regions
          other than the labeled indications have not been established in
          controlled U.S. clinical studies.
        </p>
        <p>
          As with all transcutaneous procedures, dermal filler implantation
          carries a risk of infection. Standard precautions associated with
          injectable materials should be followed.
        </p>
        <p>
          The safety for use in sites in the presence of other implants, during
          pregnancy, in breastfeeding females, and in patients with known
          susceptibility to keloid formation, hypertrophic scarring, and
          pigmentation disorders has not been studied.
        </p>
        <p>Use with caution in patients on immunosuppressive therapy.</p>
        <p>
          Patients who are using products that can prolong bleeding (such as
          thrombolytics, anticoagulants, or inhibitors of platelet aggregation)
          may experience increased bruising or bleeding at treatment sites.
        </p>
        <p>
          Patients with a history of herpetic eruptions may experience
          reactivation of the herpes.
        </p>
        <p>
          There is a possible risk of inflammation at the implant site if laser
          treatments or a chemical peel are performed after treatment.
        </p>
        <p>
          Use as supplied. Modification or use of the product outside the
          Directions for Use may adversely impact the sterility, safety,
          homogeneity, or performance of the product.
        </p>
        <p>
          For single patient use. Do not reuse a syringe between two treatments
          and/or between two patients. Do not resterilize.
        </p>
        <p>
          <u>
            <strong>Adverse Events</strong>
          </u>
        </p>
        <p>
          The most commonly reported side effects were firmness, redness,
          tenderness, swelling, lumps/bumps, bruising, discoloration, pain and
          itching. Most of these events were mild or moderate and resolved
          within 14 days.
        </p>
        <p>
          To report an adverse reaction with any RHA product, please call
          Revance at (877) 373-8669.
        </p>
      </StyledContent>
    </>
  );
}

export default ImportantSafetyInformationModal;



// WEBPACK FOOTER //
// ./src/components/modals/ImportantSafetyInformationModal.tsx